module.exports = __webpack_public_path__ + "img/1.f22560a7.png";